import { Component, Input } from '@angular/core';
import { ChronologyEvent } from '../../shared/timeline/chronology/ChronologyEvent';

@Component({
  selector: 'app-case-history',
  templateUrl: './case-history.component.html',
  styleUrls: ['./case-history.component.scss']
})
export class CaseHistoryComponent
{
  @Input() public entries: ChronologyEvent[];
}
